'use strict';

import { controlStyleObject, marginObject, labelStyleObject } from "../../app/localStorage/Props";

const angular = require('angular');

export class CommonPropertyBoxComponent {
    
    Util: any;
    $document:any;
    $uibModal:any;
    selectedView: any;
    store:any;
    filter:any;
    scope:any;
    arrayPopupproperties:any;
    ngNotification:any;
    mergedObject:any;
    StyleObject:any;
    MarginObject:any;
    PopupPropertiesObject:any;
    LabelObject:any;

    constructor(localStorage,$scope, $http, $filter, Notification, $uibModal, $document, Util, $window, $rootScope) {
       
        let self = this;
        this.Util = Util;
        this.scope =$scope;
        this.$document = $document;
        this.$uibModal = $uibModal;
        this.store = localStorage;
        this.filter=$filter;
        this.selectedView = this.store.get('selectedView');
        this.ngNotification = Notification;
        this.StyleObject=controlStyleObject;
        this.MarginObject=marginObject;
        this.LabelObject=labelStyleObject;
        this.PopupPropertiesObject={    
            Basic: {
                'Required': {
                    name: 'required',
                    selectedValue: false,
                    type: 'checkbox'
            }
        },
            Display: {
                'Read-only': {
                    name: 'read.only',
                    selectedValue: false,
                    type: 'checkbox'
                },
                'Hidden': {
                    name: 'hidden',
                    selectedValue: false,
                    type: 'checkbox'
                }
            },
            Style: angular.copy(this.LabelObject),
            ControlStyle: angular.copy(this.StyleObject),
            Margin: angular.copy(this.MarginObject),
        }
    }
    
    showMultiselectPropertybox=function() {                                                             //  For showing/hiding the button for Multiselect Properties
        let selected = this.Util.returnSelected(this.selectedView.view.controls.A);                     //  Button to be shown ONLY when atleast one control is selected.
        return (selected.length == 0);
      };
      
    multiselectPopupProperties(){
        let self = this;
        let relationModal1 = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'multiselectPopupProperties.html',
            backdrop: 'static',
            keyboard: false,
            controllerAs: '$commonpropertyboxModal',
            appendTo: angular.element(self.$document[0].querySelector('.form-builder')),
            controller: function () {                
                this.cancel = function () {
                    relationModal1.close(false);
                };
                
                this.popupProperties=self.PopupPropertiesObject;
                
                this.submitPopuppropertiesData = function(){
                    let selectedControlsProperties=self.Util.returnSelected(self.selectedView.view.controls.A);             //  Fetching the properties of selected controls.
                    
                    const mergeExisting = (controlObject, commonPropertyObject) => {                                                                 //  A custom function to merge ONLY those properties 
                        const mutableObject1 = Object.assign({}, controlObject);                                                     //  which already exist in the selected controls.
                        const mutableObject2 = Object.assign({}, commonPropertyObject);
                      
                        mergeFunction(mutableObject1, mutableObject2);
                      
                        return mutableObject1;
                      };
                      
                      const mergeFunction = (controlObject, commonPropertyObject) => {
                        Object.keys(commonPropertyObject).forEach(function (key) {
                          if (key in controlObject) {
                            if (typeof controlObject[key] === 'object') {                                                            //  Not merging the 'name' and 'hashkey' property attributes.
                                if(key!='Name' && key!='$$hashKey'){                                                             //  (cuz some contrls have styles named as 'Styles' while others have it as 'label Style')
                                mergeFunction(controlObject[key], commonPropertyObject[key]);
                                }
                            } else {
                                if(key!='Name' && key!='$$hashKey'){
                                    controlObject[key]= commonPropertyObject[key];
                                }
                            }
                          }
                        });
                    };

                    for(let i=0; i<selectedControlsProperties.length; i++){
                        mergeExisting(selectedControlsProperties[i].properties, this.popupProperties);
                    }
                    this.cancel();
                }
            }
        });
    }
}

export default angular.module('directives.commonpropertybox', [])
.component('commonpropertybox', {
    template: require('./commonPropertyBox.html'),
    controller: CommonPropertyBoxComponent,
    controllerAs: 'attrCtrl'
    
}).name;



// WEBPACK FOOTER //
// ./client/components/commonpropertybox/commonpropertybox.component.ts